export default {
  sidebar: {
    'switchSide': 'Cambia lato',
    'showSidebar': 'Mostra barra laterale',
    'hideSidebar': 'Nascondi barra laterale'
  }
}
